"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransferTaxSetting = exports.isHotelsTaxSetting = exports.isExcursionTaxSetting = exports.isCustomTaxSetting = exports.isGolfTaxSetting = void 0;
// Type guard functions for runtime validation
function isGolfTaxSetting(setting) {
    return setting.type === "golf";
}
exports.isGolfTaxSetting = isGolfTaxSetting;
function isCustomTaxSetting(setting) {
    return setting.type === "custom";
}
exports.isCustomTaxSetting = isCustomTaxSetting;
function isExcursionTaxSetting(setting) {
    return setting.type === "excursions";
}
exports.isExcursionTaxSetting = isExcursionTaxSetting;
function isHotelsTaxSetting(setting) {
    return setting.type === "hotels";
}
exports.isHotelsTaxSetting = isHotelsTaxSetting;
function isTransferTaxSetting(setting) {
    return setting.type === "transfers";
}
exports.isTransferTaxSetting = isTransferTaxSetting;
